let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("81qU5")).then(() => parcelRequire('3zF1S'));